import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { name: '首页', path: '/' },
  { name: '国产动漫', path: '/category/guoman' },
  { name: '日本动漫', path: '/category/riman' },
  { name: '剧场版', path: '/category/juchang' },
  { name: '关于我们', path: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6 lg:px-12">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 group">
            <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
              <i className="ri-play-circle-fill text-background-50 text-xl"></i>
            </div>
            <span className="font-heading text-xl text-foreground-950 whitespace-nowrap">
              51动漫
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.path;
              return (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                    isActive
                      ? 'bg-primary-500 text-background-50'
                      : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
                  }`}
                >
                  {link.name}
                </Link>
              );
            })}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button className="w-9 h-9 rounded-lg flex items-center justify-center text-foreground-600 hover:text-foreground-950 hover:bg-background-100 transition-colors cursor-pointer" aria-label="搜索">
              <i className="ri-search-line text-lg"></i>
            </button>
            <Link
              to="/about#contact"
              className="px-4 py-2 rounded-lg bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              联系我们
            </Link>
          </div>

          <button
            className="md:hidden w-9 h-9 rounded-lg flex items-center justify-center text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.path;
              return (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                    isActive
                      ? 'bg-primary-500 text-background-50'
                      : 'text-foreground-700 hover:bg-background-100'
                  }`}
                >
                  {link.name}
                </Link>
              );
            })}
            <div className="border-t border-background-200/70 mt-2 pt-2">
              <Link
                to="/about#contact"
                className="block px-4 py-3 rounded-lg bg-primary-500 text-background-50 text-sm font-medium text-center"
              >
                联系我们
              </Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}